import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { JobsState } from '@store/job/jobs.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([JobsState])],
})
export class JobsStoreModule {}
